export interface IAsProxy {
  idAsProxy: number;
  typeAsProxy: string;

  allowFreeText: boolean;
}

export const staticArrayAsProxy: IAsProxy[] = [
  {
    idAsProxy: 1,
    typeAsProxy: 'Vollmacht',
    allowFreeText: false,
  },
  {
    idAsProxy: 2,
    typeAsProxy: 'Vorsorgevollmacht / Betreuungsverfügung',
    allowFreeText: false,
  },
  {
    idAsProxy: 3,
    typeAsProxy: 'Gesetzlicher Vertreter',
    allowFreeText: false,
  },
  {
    idAsProxy: 4,
    typeAsProxy: 'Vertretung einer Gesellschaft',
    allowFreeText: false,
  },
  {
    idAsProxy: 5,
    typeAsProxy: 'Sonstiges',
    allowFreeText: true,
  },
];
